// extracted by mini-css-extract-plugin
export default {"root":"MSPOzpCB","nonFullscreen":"U7chR3We"};